import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { ResetPassword, verifyToken } from "../../Services/loginService";
import { LOGIN } from "../../routes";
import { Spinner } from "../../Components/Common";
import { PinInput } from "../../Components/Common"; // your PinInput component
import { loginpage } from "../../Assets";
import { extractErrorMessage } from "../../Utils/extractErrorMessage";

const ResetPasswordPage = () => {
  const { uid, token } = useParams();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    new_password: Yup.string()
      .min(4, "Password must be at least 4 digits")
      .required("New PIN is required"),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("new_password")], "PINs must match")
      .required("Confirm PIN is required"),
  });

  const verifyResetToken = async () => {
    try {
      const res = await verifyToken(uid, token);
      if (res.status === 200 && res.data.valid) {
        setLoading(false);
        return;
      }
      if (!res.error.valid) {
        toast.error(res.error.message || "Invalid reset link.");
        navigate(LOGIN);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Invalid reset link.");
      navigate(LOGIN);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    verifyResetToken();
  }, [uid, token]);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await ResetPassword(uid, token, {
        new_password: values.new_password,
        confirm_password: values.confirm_password,
      });
      toast.success(response.data.message || "Password reset successful!");
      navigate(LOGIN);
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to reset password."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center md:justify-end relative">
      <div className="absolute inset-0 opacity-80 bg-cover bg-center" style={{ backgroundImage: `url(${loginpage})` }} />

      <div className="flex flex-col md:mr-24 gap-8 items-center relative z-10">
        <p className="text-white z-50 text-5xl md:text-8xl font-bold">
          {process.env.REACT_APP_TITLE}
        </p>

        <div className="bg-white/40 backdrop-blur-md p-8 rounded-2xl shadow-lg w-full max-w-md">
          <div className="flex flex-col items-center mb-4">
            <p className="text-center text-2xl text-primary mt-4 font-semibold">
              Reset PIN
            </p>
          </div>

          <Formik
            initialValues={{ new_password: "", confirm_password: "" }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form className="flex flex-col gap-4 w-full text-green" autoComplete="off">
                {/* New PIN */}
                <PinInput name="new_password" label="New PIN" />

                {/* Confirm PIN */}
                <PinInput name="confirm_password" label="Confirm PIN" />

                {/* Submit */}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full flex justify-center items-center bg-primary text-white p-2 rounded hover:bg-blue-700"
                >
                  {isSubmitting ? <Spinner /> : "Reset PIN"}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
